<template>

    <div class="col-sm-12 contact_form add-prd-item">
       <!-- <h6>Add New Item </h6> -->
        <h6>Add New Variation <span v-if="product.product_groups_set_name">(Set {{product.product_groups_set_name}})</span></h6>
        <form class="gw-form" style="margin-top:1em; width:100%;">
            <div class="row">
                <!-- <div class="col-md-12" v-if="product.product_service == 'P'"><h4 style="font-size:14px;">Colour Group:</h4></div>
                <div class="col-md-12" v-if="product.product_service == 'S'"><h4 style="font-size:14px;">Service Package Group:</h4></div>    -->
                <div v-if="product.product_set_groups > 0" style="width:100%;">
                    <div class="col-md-12">
                        <label class="line-wrap">
                            <input type="radio" v-model="showProductItemGroups" value="showtrue" style="height:1em;">
                                <!-- Select from previously added <span v-if="product.product_service == 'P'">colours</span>
                                <span v-if="product.product_service == 'S'">service packages</span> -->
                            Add new Items to <span>{{product.product_groups_set_name}}</span>
                        </label>
                    </div> 
                    <div class="col-md-12">
                        <label class="line-wrap" style="">
                            <input type="radio" v-model="showProductItemGroups" value="showfalse" style="height:1em;">
                                Or Add new {{product.product_groups_set_name}}
                        </label>
                     </div>
                    <div class="clearfix"></div>
                </div>
                <!--else new product color or service plan group-->
                <!-- <div class="col-md-12" style="margin-top:-1em;">
                    
                    <div v-if="product.product_set_groups == 0">
                        <label>
                            <b>Add new {{product.product_groups_set_name}}</b>
                        </label>
                    </div>
                    <div v-else style="margin-top:1.3em;">
                        <label class="line-wrap" style="">
                            <input type="radio" v-model="showProductItemGroups" value="showfalse" style="height:1em;">
                                Or Add new {{product.product_groups_set_name}}
                        </label>
                    </div>
                </div>  -->
                    
                   
                    <!----->
                    <div class="col-md-12">
                        <div v-if="showProductItemGroups == 'showtrue'">
                            <div class="row col-md-12" v-if="(product.product_item_groups.length && product.product_item_groups.length > 0)" style="width:100%;">
                                <div class="col-xs-2" v-for="(pg,pgdex) in product.product_item_groups" :key="pgdex">
                                    <div style="padding:5px; margin-bottom:5px; width:10%">
                                        <a :title="pg.product_item_group_name" style="cursor:pointer;" @click="setComponent('set-product-item-group',pg.product_item_group_id)">
                                        <div v-if="pg.product_item_group_is_color_image == 'IMG'">
                                            <div class="box-color-cube">
                                                <img :src="pg.product_item_group_image" :id="pg.product_item_group_id+'PRTGR'" class="product-item-group sp-prd-img" style=""/>
                                            </div>
                                        </div>
                                        <div v-if="pg.product_item_group_is_color_image == 'COL'">
                                            <div :id="pg.product_item_group_id+'PRTGR'" class="product-item-group">
                                                <div class="box-color-cube" v-bind:style="{background: pg.product_item_group_color}"  style="height:3em; width:85%;"></div>
                                            </div>
                                        </div>
                                        <p style="font-weight:bold; font-size:12px; line-height:1.2;">Add to {{pg.product_item_group_name}} </p>
                                        </a>
                                    </div> 
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div v-if="showProductItemGroups == 'showfalse'">
                            <div class="form-group">
                                <label>Name
                                <input type="text" v-model="product.product_item_group_name" class="form-control"></label>
                            </div>
                            <div class="" v-if="product.product_service == 'P'">
                                <label> Pick Colour or Pick from uploaded Images to match the colour you are adding</label>
                            </div>
                            <div class="form-group" v-if="product.product_service == 'P'">
                                <label style="font-size:12px;"> Pick Colour
                                    <input type="color" v-model="product.product_item_group_color"  class="form-control" style="width:4em;">
                                </label>
                            </div>
                            <div class="form-group" style="border:1px dashed #eeccee; padding:1em;">
                                <label style="font-size:12px;"> Or Pick Media</label>
                                <div class="row img-row">
                                    <div id="groupImage" class="col-xs-1" v-for="(img,index) in product.product_images" :key="index" style="height:50px; width:70px;">
                                    <a style="cursor:pointer;" @click="setComponent('set-product-item-group-image',img.product_image_id)">
                                        <img :id="img.product_image_id+'PRTG'" class="product-item-group-image sp-prd-img" :src="img.product_image"  alt="">
                                        </a>
                                    </div>
                                </div>
                                <!-- <hr/> -->
                                <div class="clearfix"></div>
                                <div class="col-xs-12" style="z-index:9">
                                    <p class="p-tiny-info">{{max_media_info}}</p>
                                        <div class="upload-btn-wrapper" style="cursor:pointer;">
                                            <button class="upload-btn" style="line-height:0.4;font-size:14px;">Or Add new Image or Video </button>
                                            <input type="file" id="input-file" @change="onFileChange($event,'products',product.product_id)" accept="video/*,image/*" capture/>
                                        </div>
                                    <p class="data-error-message">{{data_media_error_message}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <br>
                    </div>
                    <div class="row col-md-12" v-if="(showProductItemGroups == 'showtrue') || (showProductItemGroups == 'showfalse')">
                        <!-- <div class="col-md-12"><label><h4 style="font-size:14px;">Enter Details of New Group Item</h4></label></div> -->
                        <div class="col-md-4 col-xs-3" v-if="product.product_service == 'S'">
                            <label> Service Tag
                                <input type="text" v-model="product.product_item_service_tag"  placeholder="" class="form-control">
                            </label>
                        </div>

                        <div class="col-md-3 col-xs-3">
                            <label> Price
                                <input type="number" v-model="product.product_item_price" value="" placeholder="" class="form-control">
                            </label>
                        </div>
                        
                        <div class="col-md-3 col-xs-3" v-if="product.product_service == 'P'">
                            <label> Weight(KG)
                                <input type="number" v-model="product.product_item_weight"  step="any" placeholder="" class="form-control">
                            </label>
                        </div>

                        <div class="col-md-3 col-xs-3">
                            <label> Quantity
                                <input type="number" v-model="product.product_item_quantity"  placeholder="" class="form-control">
                            </label>
                        </div>

                        <div class="col-md-3 col-xs-3" v-if="product.product_service == 'P'">
                            <label>Attributes (eg: Size, Plan, Length etc,)
                                <input type="text" v-model="product.product_item_size"  placeholder="" class="form-control">
                            </label>
                        </div>


                   
                        <div class="col-md-6">
                            <p class="data-error-message">{{data_error_message}}</p>
                            <p class="data-success-message">{{data_success_message}}</p>
                            <div v-if="action_loading" class="loading-sm"></div>
                            <button :disabled="disable_btn" type="button" class="btn admin-btn" style="background:#e7e8e9;" @click="addProductItem">Add</button>
                            <!-- <button class="btn" type="button"  @click="setComponent('reset-edit','')"><i class="icon-ban"></i> Cancel</button> -->
                        </div>
                    </div>
            </div>
        </form>
    </div>
</template>
<style>
  /*form*/
  .contact_form li {
	text-align: left;
	margin-bottom: 10px;
}
.contact_form li input {
	display: inline-block;
	width: 100%;
	height: 35px;
	padding: 0 10px;
	margin-top: 5px;
}
.contact_form li .error {
	border: 1px solid #CCC;
	border-bottom: 1px solid red;
}
.contact_form li .form-control {
	height: 45px;
	border: 1px solid #2d3a4b;
	box-shadow: none;
	border-radius: 0px;
	background: #fff;
}
.contact_form li textarea {
	height: 140px !important;
	width: 340px;
	margin-top: 10px;
}
.contact_form li .btn {
	text-transform: uppercase;
	padding: 0px 40px;
	height: 45px;
	line-height: 45px;
	font-size: 14px;
	margin-top: 15px;
}
.contact_form li .btn:hover {
	background: #ffffff;
}
.contact-form .tittle {
	text-align: center;
}
.contact-form .tittle hr {
	width: 28px;
	height: 5px;
	margin: 15px auto;
	background: #448aff;
	border: none;
}
.contact-form .tittle p {
	text-transform: none;
	font-size: 16px;
}
.contact-form label {
	font-weight: normal;
	color: #2d3a4b;
	font-size: 12px;
	text-transform: uppercase;
	display: inline-block;
	width: 100%;
	margin: 0px;
	margin-bottom: 13px;
}
.contact-form textarea {
	display: inline-block;
	width: 100%;
	position: relative;
	padding: 10px 20px;
}



</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductItemForm',
    data () {
        return {
            user:{},
            sellpoint: {},
            product:{},
            product_items: {},
            service_duration:"",
            disable_btn: false,
            imageForm: "",
            addProductItemPanel: false,
            showProductItemGroups: true,
            showAddNewProductItemGroup: false,
            loading:false,
            action_loading:true,
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
        }
    },
    components: {
       
     },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent(attr1,attr2){
            //this.setPanel = true;
            if(attr1 == 'add-product-item'){
                this.addProductItemPanel = true;
            
            }
            if(attr1 == 'reset-edit'){
               
                //  document.getElementsByClassName('add-prd-item').style.display = 'none';
            }
            if(attr1 == 'set-product-item-group'){
                this.product.product_item_group = attr2;
                //styling to show selecte active group
                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                } 
                // document.getElementById(attr2+"PRTGR").style.border = "1px solid #0000CC";
                document.getElementById(attr2+"PRTGR").style= "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if(attr1 == 'set-product-item-group-image'){
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                //    imgs[i].style = "padding:20px;border:1px solid #bbb;";
                } 
                document.getElementById(attr2+"PRTG").style.border = "1px solid #0000CC";
            }
            
            if(attr1 == 'show-product-item-group'){
                if(this.showAddNewProductItemGroup){
                    this.showAddNewProductItemGroup = false;
                }
                if(this.showProductItemGroups){
                    this.showProductItemGroups = false;
                }else{
                    this.showProductItemGroups = true;
                }
                // this.showProductItemGroups = true;
            }
            if(attr1 == 'show-add-product-item-group'){
                if(this.showProductItemGroups){
                    this.showProductItemGroups = false;
                    this.showAddNewProductItemGroup = true;
                }
                else if(this.showAddNewProductItemGroup){
                    this.showAddNewProductItemGroup = false;
                    this.showProductItemGroups = true;
                }
                // else{
                //     this.showAddNewProductItemGroup = true;
                // }
                // this.showAddNewProductItemGroup = true;
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.setProduct();
                    }else {
                        this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        setProduct(){
           this.action_loading = true;
            service.getProductSearch(this, localStorage.getItem("viewing-01")).then(response => {
                if(response.body.status == 200) {
                    this.product = response.body.data;
                    this.action_loading = false;

                    //some settings
                    if(this.product.product_set_groups == 0){
                        this.showProductItemGroups = 'showfalse'; //no items found
                    }
                    // if(this.product.product_item_groups.length == 0){
                    //     this.showAddNewProductItemGroup = true;
                    //     this.showProductItemGroups = false; //no items found
                    // }
                }
            }).catch((err) => {
                //log it
                this.action_loading = false;
                //this.$router.push("/")
            })
        },

        

        addProductItem(){
            // this.disable_btn = true;
            this.activate_processing();
            let new_product_item_group = false;
            let product_item_group_is_color_image = 'IMG';
            if(this.product.product_item_group == undefined){
                new_product_item_group = true;
            }
            if(this.product.product_item_group_color == undefined){
                product_item_group_is_color_image = 'IMG';
            }else{
                product_item_group_is_color_image = 'COL';
            }
            var credentials = {
                //new product_items_group_details
                product_new_product_item_group: new_product_item_group,
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product.product_item_group_color || "Nill",
                product_item_group_image: this.product.product_item_group_image || 0,
                //./..new .product_items_group_details
                
                product_item_group: this.product.product_item_group || 1, //default add to ist group
                
                product_id: this.product.product_id,
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1,
                product_item_size: this.product.product_item_size || "Nill",
                product_item_service_tag: this.product.product_item_service_tag || "Nill",
                product_item_service_duration: (this.product.product_item_service_duration + this.service_duration) || '1 year',
            }

            let navi = this.$router;
            if(credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                    // toastr.success("Product Item Added Successfully", 'Success!');
                        
                        //add image
                        // let result = data.body.data;
                        // this.imageForm.append("data_id", result.product_item_id);
                        // this.imageForm.append("data_type","product_items");
                        // service.uploadDataPhoto(this, this.imageForm).then(data => {
                        //    if(data.body.status == 200){
                        //         //this.product.product_image = data.body.data;
                        //         location.reload(true);
                        //     }
                        // }).catch((err) => {
                        //         if(err) {
                        //         // log it
                        //         }
                        // })

                        // location.reload(true);
                        // navi.push("account")
                        //  navi.push("account")
                        location.replace("/account");
                    }
                }).catch((err) => {
                    if(err) {
                        this.data_error_message = "Something went wrong", 'Warning!'; 
                    // toastr.warning("Something went wrong", 'Warning!'); 
                    //  console.log(err)
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                // this.disable_btn = false;
                this.deactivate_processing();
            }
        },

        //uploads
        onFileChangeXX(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {
            let formData = new FormData();
            formData.append('photo', files[0]); 
            // formData.append('data_id', data);
            // formData.append('data_type', type);   

            this.imageForm = formData;
            // service.uploadDataPhoto(this, formData).then(data => {
            //     if(data.body.status == 200){
            //         this.product.product_image = data.body.data;
            //     }
            //     }).catch((err) => {
            //         if(err) {
            //            // log it
            //         }
            //     })
        }   
            
        },
    
        onFileChange(e,type,data_id) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "products"){
                            this.product.product_item_group_image = data.body.data_id;
                            this.data_media_error_message = "";
                            this.getProductImages();
                        }
                    }
                }).catch((err) => {
                    if(err) {
                        // log it
                    }
                })
                //if uploading takes time continue with reload
                this.data_media_error_message = service.media_upload_timeout_msg;
                let self = this;
                setTimeout(function(){  self.data_media_error_message; }, 65000); //wait for 1min and timeout
                setTimeout(function(){  
                    // location.reload(true); 
                    self.data_media_error_message = "";
                }, 95000); //wait for 1min and timeout
            }   
                
        },

        getProductImages(){
            service.getProductImages(this,this.product.product_id).then(response => {
                if(response.body.status == 200) {
                    this.product.product_images = response.body.data;
                }
            }).catch((err) => {})
                
        },

},
    created: function(){
        //this.preset();
        this. imageForm = new FormData();
        this.setProduct();
    }
}

</script>


// WEBPACK FOOTER //
// ProductItemForm.vue?d25ae84e